export default "__VITE_ASSET__BMxp56wh__"